import ReactEDSWrapper from '../../utils/react-eds-wrapper';
import { Button, Dialog } from '@dsi/react-eds';
import styles from './swgw-scanning/SwgwScanning.module.css';
import { useEffect } from 'react';
import ReactDOM from 'react-dom';

export interface DeleteRepositoryDialogProps {
  open: boolean;
  repositoryName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteRepositoryDialog: React.FC<DeleteRepositoryDialogProps> = ({ open, repositoryName, onConfirm, onCancel }) => {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  return ReactDOM.createPortal(
    <ReactEDSWrapper
      component={Dialog}
      show={open}
      onClose={onCancel}
      title="Delete Repository"
      subtitle="External Repository"
      bottom={
        <ReactEDSWrapper
          component={Button}
          variant="primary"
          className="btn primary"
          type="button"
          onClick={onConfirm}
        >
          Delete Repository
        </ReactEDSWrapper>
      }
    >
      <div className={styles.whiteText}>
        You're about to delete <strong>{repositoryName}</strong>.<br />
        This action is permanent and cannot be undone.<br /><br />
        Are you sure you want to continue?
      </div>
    </ReactEDSWrapper>, document.body
  );
};

export default DeleteRepositoryDialog;
